<template>
    <div class="cards">
        <unit-card
            unit-type="SAPPER"
            image-name="sapper.png"
            :quantity="5"
        />
        <unit-card
            unit-type="SIEGE_TOWER"
            image-name="siege_tower.png"
            :quantity="5"
        />
        <unit-card
            unit-type="TREBUCHET"
            image-name="trebuchet.png"
            :quantity="5"
        />
        <unit-card
            unit-type="WAR_WAGON"
            image-name="war_wagon.png"
            :quantity="4"
        />
    </div>
</template>

<script>
export default {
    name: 'cards',
    methods: {

    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .cards {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .unit-card {
            margin: 25px;
        }
    }

</style>
